module.exports = __webpack_public_path__ + "img/york.b342f4a0.jpg";